// 
export const BOOKING_LIST = 'BOOKING_LIST';
export const BOOKING_CANCEL_LIST = 'BOOKING_CANCEL_LIST';
export const BOOKING_CANCEL_PAGINATION = 'BOOKING_CANCEL_PAGINATION';
export const BOOKING_PAGINATION = 'BOOKING_PAGINATION';
export const BOOKING_SUMMARY = 'BOOKING_SUMMARY';
export const BOOKING_CANCEL_SUMMARY = 'BOOKING_CANCEL_SUMMARY';
